import { IBrandCategory } from "../../../Models/IBrandCategory";
import { VoidGapFiltersEnum } from "../Enums/VoidGapFilters";
import { AreaType, GeographyDefinition, GrowthPeriod, GrowthType, MarketPresenceOptions, NumericComparison, SquareFootageOptions, UnitsAndGrowthOptions } from "../Models/Requests/IVoidGapRequest";
import { SET_VG_FILTERS, SET_VG_FILTER_VIEW, VoidGapActionType } from "../Types/VoidGapActionTypes";
import { VoidGapFilterMap } from "../Types/VoidGapFilterTypes";
export interface IVoidGapReducerState {
    voidGapFilterMap: VoidGapFilterMap;
    voidGapFilterView: VoidGapFiltersEnum;
};

const defaultDefinition: GeographyDefinition = {
    areaType:AreaType.None,
    geographyType:null,
    geographyKey:'',
    mileRadius:0,
    driveTime:0,
};

export const voidGapReducerDefaultState: IVoidGapReducerState = {
    voidGapFilterMap: {
        [VoidGapFiltersEnum.TenantCategory] : [] as string[],
        [VoidGapFiltersEnum.MarketPresenceAndVoid] : {
            geographyDefinition: {...defaultDefinition},
            tradeAreaDefinition: {...defaultDefinition},
            showTenants: false,
            numberOfLocations: [NumericComparison.EqualTo, 0],
        } as MarketPresenceOptions,
        [VoidGapFiltersEnum.SquareFootage] : {min: 0, max: 0} as SquareFootageOptions,
        [VoidGapFiltersEnum.UnitsAndGrowth] : {
            minLocations:0,
            maxLocations:0,
            growthType:GrowthType.GrowthRate,
            growthPeriod:GrowthPeriod.Last12Months,
            rate:0,
        } as UnitsAndGrowthOptions
    },
    voidGapFilterView: VoidGapFiltersEnum.Default
};

export const voidGapReducer = (
    state: IVoidGapReducerState = { ...voidGapReducerDefaultState },
    action: VoidGapActionType
): IVoidGapReducerState => {
    switch (action.type) {
        case SET_VG_FILTERS:
            return {
                ...state,
                voidGapFilterMap: action.data as VoidGapFilterMap
            };

        case SET_VG_FILTER_VIEW:
            return {
                ...state,
                voidGapFilterView: action.data as VoidGapFiltersEnum
            };
        default: {
            return state;
        }
    }
};
